import Typography from "@marginly/ui/components/typography";
import React from "react";

import Space from "@/components/common/space";
import { CONTEST_ID, COUNT_LINES } from "@/components/raffle/constants";
import { useGetContestRaffles } from "@/components/raffle/hooks";
import { CommonModal } from "@/components/raffle/results/common-modal/common-modal";
import { formatNum } from "@/lp/util/format";

import { GroupedTickets, Header, RaffleLine } from "./won-tickets-modal.styled";

export const WonTicketsModal = ({
  tickets,
  onHide,
}: {
  tickets: Ticket[];
  onHide?: () => void;
}) => {
  const raffles = useGetContestRaffles(CONTEST_ID);
  const wonAmount = tickets.reduce(
    (sum, ticket) => sum + ticket.winAmountUsd,
    0,
  );

  const groupedTickets = tickets.reduce((grouped, ticket) => {
    if (!grouped[ticket.raffleId]) {
      grouped[ticket.raffleId] = [];
    }
    grouped[ticket.raffleId].push(ticket);
    return grouped;
  }, [] as Ticket[][]);

  return (
    <CommonModal
      onHide={onHide}
      header={
        <Header>
          <Typography headerL>You won ${formatNum(wonAmount)}</Typography>
        </Header>
      }
    >
      {raffles.map((raffle) => {
        const raffleTickets = groupedTickets[raffle.id];
        if (!raffleTickets?.length) return null;
        return (
          <GroupedTickets key={raffle.id}>
            <Space height={24} heightMobile={24} />
            <Typography headerS>{COUNT_LINES[raffle.index]} Raffle</Typography>
            <Space height={12} heightMobile={12} />
            {raffleTickets?.map((ticket) => (
              <RaffleLine key={ticket.number}>
                <span className="wide">
                  <span className="number">
                    {ticket.winAmountUsd === 1000 ? (
                      <img src="/images/prize-1000.png" alt="" />
                    ) : ticket.winAmountUsd === 50 ? (
                      <img src="/images/prize-50.png" alt="" />
                    ) : (
                      <img src="/images/ticket-green.svg" alt="" />
                    )}
                    #{ticket.number}
                  </span>
                </span>
                <span className="win-amount">Won ${ticket.winAmountUsd}</span>
              </RaffleLine>
            ))}
          </GroupedTickets>
        );
      })}
    </CommonModal>
  );
};
